const errorReducerV2 = (reducer, actionName) => (state, action) => {
  const {type} = action;
  const matches = new RegExp("(FETCH|SAVE|DELETE)\\.(.*)\\.(REQUEST|SUCCESS|FAILURE)").exec(type);

  if (!matches) {
    return reducer(state, action);
  }

  const [,, requestName, ] = matches;
  const applyErrorReducer = (Array.isArray(actionName) && actionName.includes(requestName)) || actionName === requestName;
  if (!applyErrorReducer){
    return reducer(state, action);
  }
  const code = (action.error) ? action.error.code : undefined;
  const content = (action.error) ? action.error.content : undefined;
  return reducer({...state, error:{content, code}}, action);
}


export default errorReducerV2
